import React, { Component } from 'react'
import { Input } from "reactstrap";
import { storedb } from '../client/storedb'

export class CheckboxExt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      BtnPermissionsRoles: storedb().getPermissionsRoles()
    };
  }
  render() {
    const {
      chkClass,
      checkId,
      onClick,
      displayText,
      permission,
    } = this.props
    const { BtnPermissionsRoles } = this.state;
    let hasPermission = true;
    if (permission && permission != '') {
      hasPermission = BtnPermissionsRoles.indexOf(permission) > -1 ? true : false;
    } else if (permission === undefined) {
      console.warn(`button [${displayText}] chưa gắn với quyền nào`)
    }
    const centerStyle = {
      margin: '0 auto',
      right: '0',
      left: '0'
    };

    if (hasPermission) {
        return (
        <label className="checkcustom">
          <Input type="checkbox" id={'checkbox-'+ checkId}
            onClick={() => onClick()} className ={chkClass}>
          </Input>
          <span className="checkmark" style={centerStyle}></span>
        </label>
        )

    } else {
      return null
    }
  }
}

export default CheckboxExt


// WEBPACK FOOTER //
// ./src/views/controls/CheckboxExt.js